<modal>
  <span header>{{group.ID > 0 ? ('Chỉnh sửa' | lang) + ' ' + group.Name : ('Tạo nhóm mới' | lang)}}</span>

  <p>{{'Tên nhóm' | lang}}</p>
  <input type="text" [(ngModel)]="group.Name" />
  <p>{{'Chú thích' | lang}}</p>
  <input type="text" [(ngModel)]="group.Description" />

  <div class="flex">
    <button class="text-white bg-success" (click)="save()"><i class="fa fa-save"></i><span>{{'Lưu' | lang}}</span></button>
    <button class="text-white bg-warning" (click)="close()"><i class="fa fa-arrow-left"></i><span>{{'Quay lại' | lang}}</span></button>
  </div>
</modal>
